import { useSyncExternalStore } from "react"

const subscribe = () => () => {}
const getSnapshot = () => true
const getServerSnapshot = () => false

/**
 * Returns `false` while prerendering and during the first client render, `true`
 * from the second render on. Browser-only state (URL params, storage) must not
 * influence the first client render, otherwise it no longer matches the
 * prerendered HTML and React discards it with a hydration error.
 */
export function useIsHydrated(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
